import type { BoxTruckVerification } from '../services/boxTruckLoadsApi'

/**
 * Pin selected drivers in selection order, then keep the remaining picker rows locatable-first. On the
 * unfiltered list, include selected drivers that fell outside the fetched page; filtered lists only pin rows
 * that match the active filter.
 */
export const orderDriverPickerRows = (
    rows: BoxTruckVerification[],
    selected: BoxTruckVerification[],
    includeSelectedMissingFromRows: boolean
): BoxTruckVerification[] => {
    const rowsById = new Map(rows.map((driver) => [driver.userId, driver]))
    const selectedIds = new Set<string>()
    const pinned: BoxTruckVerification[] = []

    for (const selectedDriver of selected) {
        if (selectedIds.has(selectedDriver.userId)) continue
        selectedIds.add(selectedDriver.userId)
        const currentDriver = rowsById.get(selectedDriver.userId)
        if (currentDriver) pinned.push(currentDriver)
        else if (includeSelectedMissingFromRows) pinned.push(selectedDriver)
    }

    const unselected = [...rowsById.values()]
        .filter((driver) => !selectedIds.has(driver.userId))
        .sort((left, right) => Number(!!right.lastLocation) - Number(!!left.lastLocation))

    return [...pinned, ...unselected]
}
